import { ISecurityPayload, LoginMode, SecurityActions, SecurityActionTypes } from '../../Actions/Security/ActionTypes';

const emptySecurity: ISecurityPayload = {
  username: undefined,
  password: undefined,
  token: undefined,
  message: undefined,
  loginMode: LoginMode.NORMAL
};

export const initialState: ISecurityState = {
  security: emptySecurity
};

export interface ISecurityState {
  security: ISecurityPayload;
}

export function reducer(state = initialState, action: SecurityActions) {
  switch (action.type) {
    case SecurityActionTypes.LOGIN_USER:
      return { ...state, ...action.payload };

    case SecurityActionTypes.LOGOUT_USER:
      return { ...initialState, security: { loginMode: state.security.loginMode } };

    case SecurityActionTypes.UNAUTH_USER:
      return { ...initialState, security: { message: action.payload.message, loginMode: state.security.loginMode } };

    default:
      return state;
  }
}
